import * as React from 'react'
import { HttpStatus } from '@shopping/common'
import Error, { MessageTypes } from 'common/components/Error'

export default {
  path: '(.*)',

  action: async () => {
    return {
      component: <Error message={MessageTypes.NOT_FOUND} />,
      title: MessageTypes.getMessages(MessageTypes.NOT_FOUND).title,
      httpStatus: HttpStatus.NOT_FOUND,
    }
  },
}
